import { Component, OnInit, Input, Output, EventEmitter, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

import { ApplicationState, Patient } from "../../shared/types";
import { MedicalDataModel } from "../medical-data.model";

@Component({
	selector: "medical-data",
	templateUrl: "overview.component.html",
	standalone: false,
})
export class OverviewComponent implements OnInit {
	private readonly medicalData = inject(MedicalDataModel);
	private readonly store = inject<Store<ApplicationState>>(Store);

	// @ts-expect-error TS2564
	@Input() patient: Patient;
	@Output() details = new EventEmitter();
	// @ts-expect-error TS2564
	meddata$: Observable<any>;

	ngOnInit() {
		this.medicalData.loadMedicalData(this.patient.id);

		this.meddata$ = this.store.select((state) => state.data.medicalData[this.patient.id]);
	}
}
